var __awaiter =
  (this && this.__awaiter) ||
  function(thisArg, _arguments, P, generator) {
    function adopt(value) {
      return value instanceof P
        ? value
        : new P(function(resolve) {
            resolve(value);
          });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
      function fulfilled(value) {
        try {
          step(generator.next(value));
        } catch (e) {
          reject(e);
        }
      }
      function rejected(value) {
        try {
          step(generator["throw"](value));
        } catch (e) {
          reject(e);
        }
      }
      function step(result) {
        result.done
          ? resolve(result.value)
          : adopt(result.value).then(fulfilled, rejected);
      }
      step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
  };
import * as fs from "fs";
export class FileManagerNodeJs {
  readFileSync(path, options) {
    return fs.readFileSync(path, options);
  }
  readJsonFileSync(path, options) {
    var file = fs.readFileSync(path, options);
    return JSON.parse(file.toString());
  }
}
export class FileManagerOnline {
  // readFileSync(path, options) {
  //   return fs.readFileSync(path, options);
  // }

  readFileSync(filePath, mimeType = "text/string") {
    const xmlhttp = new XMLHttpRequest();
    xmlhttp.open("GET", filePath, false);
    // if (mimeType != null) {
    //   if (xmlhttp.overrideMimeType) {
    //     xmlhttp.overrideMimeType(mimeType);
    //   }
    // }
    xmlhttp.setRequestHeader("Content-type", "charset=UTF-8");
    xmlhttp.send();
    if (xmlhttp.status == 200 && xmlhttp.readyState == 4) {
      return xmlhttp.responseText;
    } else {
      // TODO Throw exception
      return null;
    }
  }

  async readFileAsync(filePath) {
    try {
      const response = await fetch(filePath, { mode: "no-cors" });
      const text = await response.clone().text();

      let i = text.indexOf("encoding=");
      let encoding = "UTF-8";
      if (i !== -1) {
        let st = text.substring(i + 10);
        encoding = st.substring(0, st.indexOf('"'));
      }
      const buffer = await response.arrayBuffer();

      const decoder = new TextDecoder(encoding);

      return decoder.decode(buffer);
    } catch (ex) {
      console.error("readFileAsync", filePath, ex);
    }
  }

  readJsonFileSync(filePath, mimeType = "text/json") {
    const res = this.readFileSync(filePath, mimeType);
    return res ? JSON.parse(res) : null;
    // const xmlhttp = new XMLHttpRequest();
    // xmlhttp.open("GET", filePath, false);
    // if (mimeType != null) {
    //   if (xmlhttp.overrideMimeType) {
    //     xmlhttp.overrideMimeType(mimeType);
    //   }
    // }

    // xmlhttp.send();
    // if (xmlhttp.status == 200 && xmlhttp.readyState == 4) {
    //   return JSON.parse(xmlhttp.responseText);
    // } else {
    //   // TODO Throw exception
    //   return null;
    // }
  }
}

//# sourceMappingURL=FileManager.js.map
